export const SideBarData = [
  {
    title: "Recibos pendientes de enviar",
    icon: "shopping cart",
    link: "/pendientes",
    subMenuItems: [],
  },
  {
    title: "Histórico de recibo enviados",
    icon: "history",
    link: "/historicos",
    subMenuItems: [],
  }
];
